import React, { Component } from "react";
import { config } from "config/index";
import Loader from "components/common/Loader";
import PlanPayment from "containers/PlanPayment";
import { localStore } from "stores/localStorage";
import { withRouter } from "react-router-dom";
import _get from "lodash.get";
import PlanAndPricing from "containers/PlanAndPricing";

class SentimentTrackerPaymentContainer extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <PlanAndPricing
        productCode={config.productCodes.SENTIMENT}
        paymentType="INITIAL"
      />
    );
  }
}

export default withRouter(SentimentTrackerPaymentContainer);
